import React from "react";
import { Tab, Tabs, withStyles } from "@material-ui/core";

const OnTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "20px",
    color: "#8e9aaf",
    boxSizing: "border-box",
    marginRight: "1%",
    minHeight: "auto",
    padding: "8px 12px",
    backgroundColor: "transparent",
    borderRadius: "12px",
    transition: "all 0.3s ease",
    
    "&:hover": {
      color: "#08C5A7",
      opacity: 1,
      backgroundColor: "rgba(8, 197, 167, 0.08)",
    },
  },
  selected: {
    color: theme.palette.primary.main,
    opacity: 1,
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  disabled: {
    color: theme.palette.primary.main,
  },
}))((props) => <Tab disableRipple {...props} />);

const CustomTab = withStyles((theme) => ({
  root: {
    lineHeight: "18px",
    fontSize: "14px",
  },
}))((props) => <OnTab disableRipple {...props} />);
const CustomTabs = withStyles({
  indicator: {
    backgroundColor: "transparent",
    float: "left",
  },
})((props) => (
  <Tabs
    {...props}
    variant="scrollable"
    scrollButtons="off"
    TabIndicatorProps={{ children: <div /> }}
  />
));
export { CustomTab, CustomTabs };
